module.exports = __webpack_public_path__ + "Assets/be2eb9d5-ee74-4084-b711-fe64163d1439.woff2";